import { Overlay } from '@angular/cdk/overlay';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
//import { Event as NavigationEvent, NavigationStart, NavigationExtras, Router, NavigationSkipped } from '@angular/router';
import { NavigationExtras, Router } from '@angular/router';

// import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/core/services/toast.service';
import { MdbModalRef, MdbModalService } from 'src/lib/mdb5-adapted/public-api';

import { AppDictionaryService } from './app-dictionary.service';
import { ErrorhanderService } from './core/services/error-handler.service';
import { LMSDialogComponent } from './shared/dialogs/lms-dialog/lms-dialog.component';
import { LoadSpinnerService } from './shared/loaders/spinner/loadspinner.service';
import { LMS_NotificationType, NotificationService } from './shared/notification/notification.service';

export declare type GlobalDataType = "userKey" |  "userDisplay" | "user_LoginName" | "branch_serial" | "branch_Name"| 'user_jobtitle' | "isDarkMode" | "user_Landing"|"global_toastr"|"global_lmsDialog"|"page_title";

type ServiceWrapperOptions = {
  // Legacy behavior treats any response.message as error.
  treatMessageAsError?: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class AppUtilityService extends AppDictionaryService {
  private globals: Record<string, any> = {
    ongoing_request_count: 0,
    navID: new BehaviorSubject<number>(0),
    loading_animation_control: new Subject<any>(),
    modalDialog_control: new Subject<any>(),
    banner_control: new Subject<any>(),
    page_title: '',
  };

  private lmsDialogRef: MdbModalRef<LMSDialogComponent> | null = null;

  httpOptions = {
    headers: new HttpHeaders({ 'content-type': 'application/json' }),
  };

  // 1. The private Subject holding the actual data.
  // We initialize it with a default title.
  private pageTitleSubject = new BehaviorSubject<string>('Dashboard');
  private static readonly themeStorageKey = 'lms.app.theme';

  // 2. The public Observable.
  // Components subscribe to this, but they cannot emit new values to it directly.
  public pageTitle$ = this.pageTitleSubject.asObservable();
  highlightedId: string | null = null;
  highlightType: LMS_NotificationType = 'none';
  private highlightClearTimer: ReturnType<typeof setTimeout> | null = null;
  private notificationStreamSubscription: Subscription | null = null;
  private _currentTheme: string = '';
  public currentThemeSubject = new BehaviorSubject<string>('');
  public isNavigating: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    public notificationService: NotificationService,
    private httpClient: HttpClient,
    private router: Router,
    private modalService: MdbModalService,
  //  private toastrService: ToastrService,
    private loaderService: LoadSpinnerService,
    // private lmsPageTitleService: LMSPageTitleService,
    private lmsErrorHandlerService: ErrorhanderService,
    private datePipe: DatePipe,
    private overlay: Overlay,
    private toastService: ToastService,
    //private location: LocationStrategy
  ) {
    super();
    this.subscribeToNotificationStream();
    /*
    const routedEvent$ = router.events.pipe(
      filter((event: any) => event instanceof NavigationStart),
      map((val) => val as NavigationStart),
    );

    routedEvent$.pipe(
      tap((routeevent) => {
        console.group('RestoreRoute Event');
        console.log('back::', 'old NavID: ' + this.CachedNavID);
        if (routeevent.restoredState && router.navigated) {
          if (this.CachedNavID <= routeevent.restoredState.navigationId) {
            this.info(
              'Hmmmm, noticed the page refreshedf?!',
              'What happened?!',
            );
            console.warn('>>>back::', 'Hmmmm, noticed the page refreshedf?!');
          } else {
            // preventing back button in browser implemented by "Samba Siva"
            history.pushState(null, "null", window.location.href);

            //router.navigateByUrl(router.url,{ replaceUrl: true });
            // this.warning(
            //   'Why did you use BACK?? Please dont!!!',
            //   'Please Dont!',
            // );
            console.warn(
              '>>>back::',
              'Why did you use BACK?? Please dont!!!',
            );
          }

          console.log(
            '>>>back::',
            'restoredState navigationID: ' +
                routeevent.restoredState.navigationId,
          );
          this.globals.navID.next(routeevent.restoredState.navigationId);
        } else {
          console.log('back::', 'new NavID: ' + routeevent.id);
          this.globals.navID.next(routeevent.id);
        }
        console.groupEnd();
      }),
    ).subscribe({
      next: (value) => {
        this.location.onPopState(() => {
          history.pushState(null, "null", window.location.href);
        });
        // if (value.restoredState) {
        //   console.group('NavigationStart Event');
        //   console.log('Navigation ID:', value.id);
        //   console.log('Route:', value.url!);
        //   console.log('Trigger:', value.navigationTrigger!);
        //   console.warn(
        //     'Restoring navigation ID:',
        //     value.restoredState.navigationId,
        //   );
        // }
        console.groupEnd();
      },
      complete() {
        console.groupEnd();
      },
    });
    */
  }

  serviceWrapper(
    api: string,
    responseProcessing: any,
    request_data?: any,
    skip_loading_animation?: string,
    HTTP_method?: string,
    options?: ServiceWrapperOptions,
  ): Subject<any> {
    const response_subject = new Subject<any>();
    const wrapperOptions: Required<ServiceWrapperOptions> = {
      treatMessageAsError: options?.treatMessageAsError ?? true,
    };

    // If it has not been explicitly mentioned to not show the loader, please show.
    if (!skip_loading_animation) {
      this.globals.ongoing_request_count++;
      this.globals.loading_animation_control.next(true);
    }

    // Hide snackbars and banners if any
    //this.hideSnackbar();
    //this.hideBanner();
    const apiUrl = this.getAPI(api);
    // For local API requests, fetch the JSON file instead
    // For testing
    // if (environment.dummy_JSONs) {
    //   API_URL += '.json';
    // }

    this.httpClient
      .request(HTTP_method || 'POST', apiUrl, request_data)
      .pipe(
        finalize(() => {
          if (!skip_loading_animation) {
            if (this.globals.ongoing_request_count > 0) {
              this.globals.ongoing_request_count--;
            }
            // Hide only when no active requests remain.
            if (this.globals.ongoing_request_count === 0) {
              this.globals.loading_animation_control.next(false);
            }
          }
        }),
      )
      .subscribe({
        next: (response: any) => {
          const responseMessage = response.errorMessage || response.message || '';
          const quoteError = Boolean(
            (Object.keys(response).indexOf('loanStatus') > -1 &&
              (responseMessage.includes('Error from Webfin') ||
                responseMessage.includes('Response Error'))) ||
              false);
          const hasApiError = this.hasApiErrorResponse(
            response,
            quoteError,
            wrapperOptions,
          );

          // If this is an error object directly send it across
          if (hasApiError) {
            response_subject.error(response);
          } else {
            try {
              const processed_response = responseProcessing(response);
              if (processed_response.error) {
                response_subject.error(processed_response.error);
              } else {
                response_subject.next(processed_response.data);
              }
            } catch (processingError) {
              response_subject.error(processingError);
            }
          }
        },
        complete: () => {
          this.stopLoading();
          response_subject.complete();
        },
        error: (error) => {
          this.stopLoading();
          response_subject.error(error?.error || error);
        },
      });

    return response_subject;
  }

  private subscribeToNotificationStream() {
    if (this.notificationStreamSubscription) {
      return;
    }

    const notificationStream = (this.notificationService as any)?.stream$;
    if (!notificationStream || typeof notificationStream.subscribe !== 'function') {
      return;
    }

    this.notificationStreamSubscription = notificationStream.subscribe((event: any) => {
      this.highlightedId = event.target;
      this.highlightType = event.type;

      if (this.highlightClearTimer) {
        clearTimeout(this.highlightClearTimer);
      }

      // Auto-clear highlight 2s after the latest notification event.
      this.highlightClearTimer = setTimeout(() => {
        this.highlightedId = null;
        this.highlightType = 'none';
      }, 2000);
    });
  }

  private hasApiErrorResponse(
    response: any,
    quoteError: boolean,
    options: Required<ServiceWrapperOptions>,
  ): boolean {
    const hasErrorCode = response?.errorCode !== undefined && response?.errorCode !== null;
    const hasErrorMessage = Boolean(response?.errorMessage);
    const hasMessage = Boolean(response?.message);
    const successFlag = this.readSuccessFlag(response);
    const responseCodeState = this.readResponseCodeState(response);

    if (successFlag !== null) {
      return !successFlag || hasErrorCode || hasErrorMessage || quoteError;
    }

    if (responseCodeState !== null) {
      return responseCodeState === 'error' || hasErrorCode || hasErrorMessage || quoteError;
    }

    return (
      hasErrorCode ||
      hasErrorMessage ||
      (options.treatMessageAsError && hasMessage) ||
      quoteError
    );
  }

  private readSuccessFlag(response: any): boolean | null {
    if (typeof response?.success === 'boolean') {
      return response.success;
    }

    if (typeof response?.isSuccessful === 'boolean') {
      return response.isSuccessful;
    }

    return null;
  }

  private readResponseCodeState(response: any): 'success' | 'error' | null {
    const code = Number(response?.responseCode);

    if (Number.isNaN(code)) {
      return null;
    }

    return code >= 200 && code < 300 ? 'success' : 'error';
  }

  isBusyNavigating(busy: boolean) {
    this.isNavigating.next(busy);
  }

  getCachedGPSLocation(): Promise<{ latitude: number; longitude: number; address?: string }> {
    this.startLoading('Capturing location, preparing LMS field agent processes');

    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('Geolocation not supported'));
        return;
      }

      if(sessionStorage.getItem('FieldLocation_coords')) { //&& localStorage.getItem('LocalUser') != JSON.stringify(lmsUser)) {
        const cachedCoords = JSON.parse(sessionStorage.getItem('FieldLocation_coords') || '{}');

        resolve({
            latitude: cachedCoords.latitude,
            longitude: cachedCoords.longitude,
        });
        console.log('Not Requesting new location...');
        return;
      }

       reject(new Error('No Cached Geolocation found'));

      // console.log('Requesting new location from device...');
      // navigator.geolocation.getCurrentPosition(
      //   (position) => {
      //     sessionStorage.setItem('FieldLocation_coords',JSON.stringify(position.coords));
      //     sessionStorage.setItem('FieldLocation_timestamp',JSON.stringify(position.timestamp));
      //     resolve({
      //       latitude: position.coords.latitude,
      //       longitude: position.coords.longitude,
      //       // Address can be reverse geocoded if needed, but for now just coords
      //     });
      //   },
      //   (error) => {
      //     reject(error);
      //   },
      //   { enableHighAccuracy: true, timeout: 10000 }
      // );
    });
  }

  showResponseMessage(
    title: any,
    message: any,
    isErrorOccured: boolean,
    showClose: boolean,
    onDialog: boolean,
  ) {
    if (onDialog) {
      const options = {
        title: title,
        message: !message || message == '' ? 'Please wait!' : message,
        text: message || this.error_messages.service_failure,
        showClose: showClose,
        isErrorOccured: isErrorOccured,
      };

      this.lmsDialogRef = this.modalService.open(LMSDialogComponent, {
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: true,
        nonInvasive: false,
        animation: true,
        modalClass:
          'modal-sm modal-dialog modal-dialog-centered modal-info d-flex d-flex-md',
        containerClass: 'frame modal fade show',
        data: options,
      });

      return;
    }

    if (isErrorOccured) {
      this.error(message, title);
      return;
    }
    this.info(message, title);
  }

  login(user_credentials: any) {
    const credentials = { ...user_credentials };
    return this.serviceWrapper(
      'login',
      (response: any) => {
        if (response.responseCode == 200) {
          response.data = response.data || {};
          response.data.username = user_credentials.username;
          response.data.success = response.data.success || user_credentials.username == 'error' ? false : true;
          return user_credentials.username == 'error'
            ? { error: response }
            : { data: response };
        } else {
          return { error: response };
        }
      },
      {
        body: credentials,
      },
    );
  }

  generateId() {
    return Number.parseInt(
      (Math.random() + 1).toString(36).substring(4) +
        (Math.random() + 1).toString(36).substring(4),
    );
  }

  downloadFile() {
    return this.serviceWrapper(
      'file_download',
      () => {
        //const file_name = "dummy_file.pdf";
        //saveAs(response, file_name);
        return { data: { message: 'download success' } };
      },
      {
        body: {
          dummy: 'data',
        },
        responseType: 'blob',
      },
    );
  }

  uploadFile(form_data: any, API: string) {
    return this.serviceWrapper(
      API,
      (response: any) => {
        return { data: { message: response.uploadStatus } };
      },
      {
        body: form_data,
      },
      'skip_loader_animation',
    );
  }

  setAppTheme(theme: string): void {
    this._currentTheme = theme;
    localStorage.setItem(AppUtilityService.themeStorageKey, theme);
    this.currentThemeSubject.next(theme);
  }

  initAppTheme(): string {
    const storedTheme = localStorage.getItem(AppUtilityService.themeStorageKey) ?? '';
    this._currentTheme = storedTheme;
    this.currentThemeSubject.next(storedTheme);
    return storedTheme;
  }

  getAppTheme(): string {
    return this._currentTheme;
  }

  // 3. The public method to update the title
  updatePageTitle(newTitle: string): void {
    // Only update if the title is actually different (prevents unnecessary re-renders)
    if (newTitle && newTitle !== this.pageTitleSubject.value) {
      this.globals.page_title = newTitle;
      this.pageTitleSubject.next(newTitle);

      // Optional: If you also want to update the actual browser tab title
      // document.title = `${newTitle} | CLMS`;
    }
  }

  showBanner(text?: string) {
    const options = {
      to_show: true,
      text: text || this.error_messages.service_failure,
    };
    this.globals.banner_control.next(options);
  }

  hideBanner() {
    const options = {
      to_show: false,
    };
    this.globals.banner_control.next(options);
  }

  warning(message?: string, toastTitle?: string, enableHtml?: boolean) {
    setTimeout(() => {
      const toastr_ref = this.toastService.warning(
        message || this.error_messages.service_failure,
        toastTitle || '',
        {
          timeOut: 7000,
          positionClass: 'toast-top-right',
          enableHtml: enableHtml,
          titleClass: 'h5',
        },
      );
      this.setGlobalData('global_toastr', toastr_ref);
    }, 200);
  }

  success(message?: string, toastTitle?: string) {
    setTimeout(() => {
      const toastr_ref = this.toastService.success(
        message || this.error_messages.service_failure,
        toastTitle || '',
        {
          timeOut: 6000,
          positionClass: 'toast-top-right',
        },
      );
      this.setGlobalData('global_toastr', toastr_ref);
    }, 300);
  }

  info(message?: string, toastTitle?: string) {
    setTimeout(() => {
      const toastr_ref = this.toastService.info(
        message || this.error_messages.service_failure,
        toastTitle || '',
        {
          timeOut: 6000,
          positionClass: 'toast-top-right',
        },
      );
      this.setGlobalData('global_toastr', toastr_ref);
    }, 300);
  }

  error(message?: string, toastTitle?: string) {
    setTimeout(() => {
      const toastr_ref = this.toastService.error(
        message || this.error_messages.service_failure,
        toastTitle || '',
        {
          timeOut: 5000,
          positionClass: 'toast-top-right',
        },
      );
      this.setGlobalData('global_toastr', toastr_ref);
    }, 300);
  }

  handle_returnMessage(errMessage: string) {
    this.stopLoading();
    this.lmsErrorHandlerService.handleString(
      errMessage,
      'Server result error',
      true,
    );
  }


  handleError(e: unknown, hdrString?: string, showdate = true) {
    this.stopLoading();
    this.lmsErrorHandlerService.handle(e, hdrString ?? 'Server result error', showdate);
  }

  stopLoading() {
    this.loaderService.stopLoading();
  }

  startLoading(message?: string, showTimer?: number | null) {
    let ss = showTimer || 1;
    if(showTimer && (typeof showTimer) == 'boolean') {
      ss = showTimer ? 2 : 1;
    }
    this.loaderService.startLoading(message, ss);
  }

  hideSnackbar() {
    this.getGlobalData("global_toastr")?.dismiss();
  }

  displayLMSDialog(message?: string) {
    const options = {
      to_show: true,
      message: !message || message == '' ? 'Please wait!' : message,
      text: message || this.error_messages.service_failure,
    };

    this.openModalDialog(options);
  }

  openModalDialog(data?: any) {
    const dialog_ref = this.displayDialogData({
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: true,
      modalClass:
        'modal-md modal-fluid modal-dialog-centered modal-center modal-notify modal-info lms-centered-modal',
      data: data,
    });
    return dialog_ref;

    // setTimeout(() => {
    //   const dialog_ref = this.displayDialogData(
    //     {
    //       backdrop: true, ignoreBackdropClick: true, keyboard: true,
    //       modalClass: 'modal-md modal-fluid modal-dialog-centered modal-center modal-notify modal-info',
    //       data: { data }
    //     });
    //   return dialog_ref;
    //   this.setGlobalData('global_lmsDialog', dialog_ref);
    //   //this.globals.modalDialog_control.next(dialog_ref);

    //   this.setGlobalData('global_lmsDialog', dialog_ref);
    // }, 0);
  }

  safeDivide(dividend: number, divisor: number): number {
    if (divisor === 0) {
      console.error('Division by zero prevented.');
      return 0; // or handle as needed
    }
    return dividend / divisor;
  }

  closeLMSModal(returnData?: any) {
    const returnRef = this.getGlobalData('global_lmsDialog');

    return returnRef?.close(returnData);
  }

  displayDialogData2(component: any, options?: any) {
    const global_options = {
      autoFocus: false,
      panelClass: 'lms-dialog-container',
      scrollStrategy: this.overlay.scrollStrategies.noop(),
    };
    const dialog_config = { ...global_options, ...options };

    // this.lmsDialogRef = this.modalService.open(LMSDialogComponent, {
    //   backdrop: true, ignoreBackdropClick: true, keyboard: true,
    //   modalClass: 'modal-sm modal-fluid modal-dialog-centered modal-center modal-notify modal-info',
    //   data: {
    //     message: (!message || message == '') ? "Please wait!" : message,
    //     showTimer: withTimer
    //   }
    // });

    this.lmsDialogRef = this.modalService.open(component, dialog_config);
    return this.lmsDialogRef;
  }

  private displayDialogData(options?: any) {
    // const global_options = {
    //   autoFocus: false,
    //   panelClass: 'lms-dialog-container',
    //   scrollStrategy: this.overlay.scrollStrategies.noop()
    // };
    const dialog_config = { ...options };

    // this.lmsDialogRef = this.modalService.open(LMSDialogComponent, {
    //   backdrop: true, ignoreBackdropClick: true, keyboard: true,
    //   modalClass: 'modal-sm modal-fluid modal-dialog-centered modal-center modal-notify modal-info',
    //   data: {
    //     message: (!message || message == '') ? "Please wait!" : message,
    //     showTimer: withTimer
    //   }
    // });
    this.lmsDialogRef = this.modalService.open(
      LMSDialogComponent,
      dialog_config,
    );
    return this.lmsDialogRef;
  }

  toggleFormControls(
    form_group: FormGroup,
    control_list: string[],
    to_enable: boolean,
  ) {
    const control_count = control_list.length;
    for (let i = 0; i < control_count; i++) {
      const current_control = form_group.get(control_list[i]);
      if (to_enable) {
        current_control?.enable({ emitEvent: false });
      } else {
        current_control?.disable({ emitEvent: false });
      }
    }
  }

  public findInvalidControls(form_group: FormGroup) {
    const invalid: string[] = [];
    const controls = form_group.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    this.warning(invalid.join(' '), 'Invalid controls');
    return invalid;
  }

  transformDate(date: string | number | Date): string {
    if(!date || date === 'Invalid date') {
      return '';
    }

    if (date instanceof Date) {
      return this.datePipe.transform(date, 'yyyy-MM-dd') || date.toDateString();
    }
    return this.datePipe.transform(date, 'yyyy-MM-dd') || new Date(date).toDateString();
  }

  onRouteActivation(evt: any) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  navigateToURL(URL: any[], exstras?: NavigationExtras ) {
    this.router.navigate(URL, exstras).catch((err) =>{
      this.warning(`Failed to navigate: ${err}`);
    });
  }

  navigateToLanding() {
    this.router.navigate([`${this.globals.user_Landing}` ?? 'home']).catch((err) =>{
      this.warning(`Failed to navigate: ${err}`);
    });
  }


  /* TODO
  getCookie(name: string){
    return this.cookieService.get(name);
  }

  setCookie(name, value){
    this.cookieService.set(name, value, {path: '/', expires: new Date('12/31/9999')});
  }

  deleteCookie(name){
    this.cookieService.delete(name);
  }

  */

  unsubscribeAll(subs: Subscription[]) {
    const sub_count = subs.length;
    for (let i = 0; i < sub_count; i++) {
      subs[i].unsubscribe();
    }
  }

  numberOnly(event: any, includeDecimal = false): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (includeDecimal && (charCode == 44 || charCode == 46)) {
      return true;
    }

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  setGlobalData(key: string, value: any) {
    this.globals[key] = value;
  }

  getGlobalData(key: GlobalDataType) {
    return this.globals[key.toString()];
  }

  public get CachedNavID() {
    return this.globals.navID.value;
  }

  // toggleRow(element: { expanded: boolean; }) {
  //   // Uncommnet to open only single row at once
  //   this.dataSource.forEach(row => {
  //     row.expanded = false;
  //   });
  //   element.expanded = !element.expanded;
  // }

  // manageAllRows(flag: boolean) {
  //   dataSource.forEach(row => {
  //     row.expanded = flag;
  //   });
  // }
}

